/**
* 标签卡片
* 徐杰
* 2019-4-23
**/
<template>
  <Card :shadow="shadow" class="xj-card-wrapper" :padding="0">
    <div class="xj-ico" :style="{background: color}">
      <Icon :type="icon" :size="iconSize" />
    </div>
    <div class="xj-value">
      <span class="nums">{{ nums }}</span>
      <span calss="title">{{ title }}</span>
      <!-- <slot></slot> -->
    </div>
  </Card>
</template>

<script>
export default {
    name: 'InfoCard',
    components: {},
    props: {
        nums: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#2d8cf0'
        },
        icon: {
            type: String,
            default: ''
        },
        iconSize: {
            type: Number,
            default: 20
        },
        shadow: {
            type: Boolean,
            default: false
        }
    },
    computed: {}
};
</script>

<style  scoped>
.xj-card-wrapper {
  width: 100%;
  height: 100%;
  display: table;
  text-align: center;
}

.xj-ico {
  height: 100%;
  width: 35%;
  -webkit-border-radius: 4px 0px 0px 4px;
  border-radius: 4px 0px 0px 4px;
  text-align: center;
  line-height: 86px;
  position: absolute;
  top: 0px;
  left: 0px;
  color: #fff;
}

.xj-value {
  width: 64%;
  /* height: 75px; */
  text-align: center;
  position: absolute;
  top: 1px;
  right: 1px;
  padding-top: 8px;
  color: #000;
}
.nums {
  display: block;
  width: 100%;
  height: 36px;
  line-height: 36px;
  font-size: 30px;
  color: #515a6e;
  text-align: center;
  margin-bottom: 5px;
}
.title {
  color: #515a6e;
  
}
</style>
